import {
  AccountCircle,
  Apps,
  DarkModeOutlined,
  LightModeOutlined,
  SettingsOutlined,
} from "@mui/icons-material";
import {
  Box,
  IconButton,
  Popover,
  Switch,
  Typography,
  useTheme,
} from "@mui/material";
import { useContext, useState } from "react";
import { PanelSessionContext } from "../../components/sessionContext";
import { SettingsContext } from "../../components/settingsContext";
import { ColorModeContext, getColors } from "../../theme";
import { ConnectRootPermissions } from "../../utils/types";

const TopBar = () => {
  const theme = useTheme();
  const session = useContext(PanelSessionContext);
  const colorMode = useContext(ColorModeContext);
  const colors = getColors(theme.palette.mode);
  const settings = useContext(SettingsContext);

  const [openSettings, setOpenSettings] = useState<boolean>(false);
  const [openApps, setOpenApps] = useState<boolean>(false);

  return (
    <>
      <Box display="flex" justifyContent="space-between" p={2}>
        <Box>
          <Typography variant="h3" fontWeight={"bold"}>
            IDP-CONNECT
          </Typography>
        </Box>
        <Box display="flex">
          <IconButton onClick={(e) => colorMode.toggleColorMode()}>
            {theme.palette.mode === "dark" ? (
              <DarkModeOutlined />
            ) : (
              <LightModeOutlined />
            )}
          </IconButton>
          {session.logged?.permissions.includes(
            ConnectRootPermissions.ROOT.ident
          ) && (
            <IconButton
              id="settingsTopBarBtn"
              onClick={(e) => setOpenSettings(!openSettings)}
            >
              <SettingsOutlined />
            </IconButton>
          )}
          <IconButton id="appsTopBar" onClick={() => setOpenApps(!openApps)}>
            <Apps />
          </IconButton>
        </Box>
      </Box>

      <Popover
        open={openSettings}
        onClose={() => setOpenSettings(false)}
        anchorEl={document.getElementById("settingsTopBarBtn")}
        anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
      >
        <Box sx={{ p: "2rem", width: "20rem" }}>
          <Typography variant="h3" fontWeight={500} sx={{ mb: "1rem" }}>
            Settings
          </Typography>
          <Box display="flex" flexDirection="column" gap="1rem">
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <Typography variant="h6">Development Mode</Typography>
              <Switch
                checked={settings.devMode}
                onChange={(e) => settings.setDevMode(e.currentTarget.checked)}
              />
            </Box>
          </Box>
        </Box>
      </Popover>

      <Popover
        open={openApps}
        onClose={() => setOpenApps(false)}
        anchorEl={document.getElementById("appsTopBar")}
        anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
      >
        <Box p="2rem" width="20rem">
          <Box display="flex" ml="10px" alignItems="center">
            <AccountCircle sx={{ transform: "scale(2)" }} />
            <Typography sx={{ ml: "2rem" }}>{session.logged?.name}</Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              gap: ".5rem",
              maxHeight: "15rem",
              mt: "2rem",
            }}
          >
            {session.apps.map((app) => (
              <Box
                key={app.id}
                onClick={() => (window.location.href = app.url)}
                sx={{
                  cursor: "pointer",
                  display: "flex",
                  maxWidth: "auto",
                  p: ".25rem",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  border: `3px solid ${colors.gray[600]}`,
                  borderRadius: "15px",
                }}
              >
                <img height="35px" src={`${app.url}/favicon.ico`} />
                <Typography mt="0.5rem" align="center">
                  {app.name}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
      </Popover>
    </>
  );
};

export default TopBar;
